import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinantialInformationRoutingModule } from './finantial-information-routing.module';
import { FinantialInformationComponent } from './finantial-information.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatSelectModule } from '@angular/material/select';
import { InputCurrencyPipe } from 'src/app/shared/pipes/input-currency.pipe';

@NgModule({
  declarations: [FinantialInformationComponent],
  imports: [
    CommonModule,
    FinantialInformationRoutingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    PipesModule,
    DirectivesModule
  ],
  providers: [InputCurrencyPipe]
})
export class FinantialInformationModule {}
